import { useState } from 'react';
import type { Client } from '../../types';

const clients: Client[] = [
  { id: 'c1',  initials: 'BS', name: 'Marek Sloboda',     company: 'Bratislava Pet Shop',  email: 'marek@petshop.sk',     phone: '+421 905 111 222', status: 'active',   plan: 'Growth',  mrr: 1200, projectCount: 2, since: 'Jan 2024', color: 'bg-emerald-600'  },
  { id: 'c2',  initials: 'TF', name: 'Lukáš Tóth',        company: 'TechFlow s.r.o.',      email: 'lukas@techflow.sk',     phone: '+421 911 333 444', status: 'active',   plan: 'Scale',   mrr: 2400, projectCount: 3, since: 'Mar 2024', color: 'bg-sky-600'      },
  { id: 'c3',  initials: 'VB', name: 'Nina Vargová',       company: 'VitaBenefit s.r.o.',   email: 'nina@vitabenefit.sk',   phone: '+421 902 555 666', status: 'active',   plan: 'Starter', mrr: 980,  projectCount: 1, since: 'Apr 2024', color: 'bg-violet-600'   },
  { id: 'c4',  initials: 'PK', name: 'Petra Kovárová',     company: 'Petra K. – Kozmetika', email: 'petra@kozmetika.sk',    phone: '+421 944 777 888', status: 'active',   plan: 'Starter', mrr: 650,  projectCount: 1, since: 'Jun 2024', color: 'bg-pink-600'     },
  { id: 'c5',  initials: 'ML', name: 'Róbert Mináč',       company: 'MotoLux SK',           email: 'robert@motolux.sk',     phone: '+421 918 999 000', status: 'active',   plan: 'Growth',  mrr: 1600, projectCount: 2, since: 'Jul 2024', color: 'bg-orange-600'   },
  { id: 'c6',  initials: 'DW', name: 'Dominika Weis',      company: 'DW Atelié',            email: 'dom@dw-atelie.sk',      phone: '+421 903 123 456', status: 'active',   plan: 'Starter', mrr: 490,  projectCount: 1, since: 'Aug 2024', color: 'bg-rose-600'     },
  { id: 'c7',  initials: 'FA', name: 'Filip Antoš',        company: 'FreshAir s.r.o.',      email: 'filip@freshair.sk',     phone: '+421 915 234 567', status: 'active',   plan: 'Growth',  mrr: 1100, projectCount: 2, since: 'Sep 2024', color: 'bg-teal-600'     },
  { id: 'c8',  initials: 'KG', name: 'Katarína Gál',       company: 'KG Nutrition',         email: 'katka@kgnut.sk',        phone: '+421 907 345 678', status: 'active',   plan: 'Starter', mrr: 550,  projectCount: 1, since: 'Oct 2024', color: 'bg-lime-600'     },
  { id: 'c9',  initials: 'MR', name: 'Martin Rusnák',      company: 'AutoMech Prešov',      email: 'martin@automech.sk',    phone: '+421 919 456 789', status: 'paused',   plan: 'Growth',  mrr: 0,    projectCount: 1, since: 'Feb 2024', color: 'bg-zinc-600'     },
  { id: 'c10', initials: 'JH', name: 'Jana Horváth',       company: 'JH Legal s.r.o.',      email: 'jana@jhlegal.sk',       phone: '+421 901 567 890', status: 'active',   plan: 'Scale',   mrr: 2200, projectCount: 2, since: 'Nov 2024', color: 'bg-indigo-600'   },
  { id: 'c11', initials: 'SN', name: 'Stanislav Nagy',     company: 'Nagy Stavebniny',      email: 's.nagy@stavebniny.sk',  phone: '+421 948 678 901', status: 'active',   plan: 'Starter', mrr: 480,  projectCount: 1, since: 'Dec 2024', color: 'bg-amber-600'    },
  { id: 'c12', initials: 'EK', name: 'Eva Krajčíová',      company: 'EK Dizajn Studio',     email: 'eva@ek-dizajn.sk',      phone: '+421 921 789 012', status: 'inactive', plan: 'Starter', mrr: 0,    projectCount: 0, since: 'May 2024', color: 'bg-red-700'      },
];

const statusStyle: Record<Client['status'], string> = {
  active:   'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  paused:   'bg-amber-500/10 text-amber-400 border-amber-500/20',
  inactive: 'bg-zinc-700/40 text-zinc-500 border-zinc-600/30',
};

const statusLabel: Record<Client['status'], string> = {
  active: 'Aktívny', paused: 'Pozastavený', inactive: 'Neaktívny',
};

const planStyle: Record<string, string> = {
  Starter: 'bg-zinc-700/40 text-zinc-400',
  Growth:  'bg-orange-500/10 text-orange-400',
  Scale:   'bg-sky-500/10 text-sky-400',
};

export default function AdminKlienti() {
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | Client['status']>('all');
  const [selected, setSelected] = useState<Client | null>(null);

  const filtered = clients.filter((c) => {
    const q = search.toLowerCase();
    const matchQ = c.name.toLowerCase().includes(q) || c.company.toLowerCase().includes(q) || c.email.toLowerCase().includes(q);
    const matchS = statusFilter === 'all' || c.status === statusFilter;
    return matchQ && matchS;
  });

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="flex items-center gap-3 mb-5">
        {/* Search */}
        <div className="flex items-center gap-2 bg-zinc-900 border border-zinc-800 rounded-xl px-3 py-2 flex-1 max-w-xs">
          <i className="ri-search-line text-zinc-500 text-sm" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Hľadať klienta..."
            className="bg-transparent text-zinc-300 text-sm placeholder:text-zinc-600 outline-none flex-1"
          />
        </div>

        {/* Status filter */}
        {(['all', 'active', 'paused', 'inactive'] as const).map((s) => (
          <button
            key={s}
            onClick={() => setStatusFilter(s)}
            className={`px-3.5 py-2 rounded-xl text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
              statusFilter === s
                ? 'bg-orange-500/10 border border-orange-500/20 text-orange-400'
                : 'bg-zinc-900 border border-zinc-800 text-zinc-500 hover:text-zinc-300'
            }`}
          >
            {s === 'all' ? 'Všetci' : statusLabel[s]}
          </button>
        ))}

        <div className="flex-1" />

        <button className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-semibold px-4 py-2 rounded-xl transition-all cursor-pointer whitespace-nowrap">
          <i className="ri-user-add-line text-sm" />
          Pridať klienta
        </button>
      </div>

      {/* Table */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              {['Klient', 'Kontakt', 'Plán', 'MRR', 'Projekty', 'Stav', ''].map((h) => (
                <th key={h} className="text-left px-4 py-3 text-zinc-600 text-[11px] font-semibold uppercase tracking-wider">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {filtered.map((c) => (
              <tr
                key={c.id}
                className="hover:bg-zinc-800/40 cursor-pointer transition-all"
                onClick={() => setSelected(selected?.id === c.id ? null : c)}
              >
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-xl ${c.color} flex items-center justify-center flex-shrink-0`}>
                      <span className="text-white text-xs font-bold">{c.initials}</span>
                    </div>
                    <div>
                      <p className="text-zinc-200 text-sm font-medium">{c.name}</p>
                      <p className="text-zinc-600 text-xs">{c.company}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3">
                  <p className="text-zinc-400 text-xs">{c.email}</p>
                  <p className="text-zinc-600 text-xs">{c.phone}</p>
                </td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-lg ${planStyle[c.plan]}`}>{c.plan}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-white text-sm font-bold">{c.mrr > 0 ? `${c.mrr} €` : '-'}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-zinc-400 text-sm">{c.projectCount}</span>
                </td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full border ${statusStyle[c.status]}`}>
                    {statusLabel[c.status]}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-1">
                    <button className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-zinc-700 transition-all cursor-pointer" onClick={(e) => e.stopPropagation()}>
                      <i className="ri-pencil-line text-zinc-500 text-sm" />
                    </button>
                    <button className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-zinc-700 transition-all cursor-pointer" onClick={(e) => e.stopPropagation()}>
                      <i className="ri-eye-line text-zinc-500 text-sm" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filtered.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-user-search-line text-zinc-700 text-3xl" />
            <p className="text-zinc-600 text-sm mt-2">Žiadni klienti nevyhovujú filtru</p>
          </div>
        )}
      </div>

      {/* Client detail panel */}
      {selected && (
        <div className="mt-4 bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-4">
              <div className={`w-12 h-12 rounded-2xl ${selected.color} flex items-center justify-center`}>
                <span className="text-white font-bold">{selected.initials}</span>
              </div>
              <div>
                <h3 className="text-white font-bold text-base">{selected.name}</h3>
                <p className="text-zinc-500 text-sm">{selected.company}</p>
              </div>
            </div>
            <button onClick={() => setSelected(null)} className="w-8 h-8 rounded-xl hover:bg-zinc-800 flex items-center justify-center cursor-pointer">
              <i className="ri-close-line text-zinc-500 text-lg" />
            </button>
          </div>
          <div className="grid grid-cols-4 gap-3">
            {[
              { label: 'Email',    value: selected.email,     icon: 'ri-mail-line'     },
              { label: 'Telefón',  value: selected.phone,     icon: 'ri-phone-line'    },
              { label: 'Plán',     value: selected.plan,      icon: 'ri-vip-line'      },
              { label: 'Klient od', value: selected.since,   icon: 'ri-calendar-line' },
            ].map((d) => (
              <div key={d.label} className="bg-zinc-800/50 rounded-xl p-3">
                <div className="flex items-center gap-2 mb-1">
                  <i className={`${d.icon} text-zinc-600 text-xs`} />
                  <p className="text-zinc-600 text-[10px] uppercase tracking-wider font-semibold">{d.label}</p>
                </div>
                <p className="text-zinc-200 text-sm font-medium">{d.value}</p>
              </div>
            ))}
          </div>
          <div className="flex gap-2 mt-4">
            <button className="flex items-center gap-2 bg-orange-500/10 border border-orange-500/20 text-orange-400 text-xs font-semibold px-4 py-2 rounded-xl hover:bg-orange-500/20 transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-message-3-line" /> Napísať správu
            </button>
            <button className="flex items-center gap-2 bg-zinc-800 border border-zinc-700 text-zinc-300 text-xs font-semibold px-4 py-2 rounded-xl hover:bg-zinc-700 transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-folder-open-line" /> Zobraziť projekty
            </button>
            <button className="flex items-center gap-2 bg-zinc-800 border border-zinc-700 text-zinc-300 text-xs font-semibold px-4 py-2 rounded-xl hover:bg-zinc-700 transition-all cursor-pointer whitespace-nowrap">
              <i className="ri-bill-line" /> Faktúry
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
